import Overlay from './overlay/Overlay'
import {addSlot} from "../user/ScheduleInterview"
import { LocalizationProvider, StaticDateTimePicker } from '@mui/x-date-pickers';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useState } from 'react';
import { Dayjs } from 'dayjs';

const AddSlotModal = ({isOpen, onClose}: {
    isOpen: boolean
    onClose: () => void;
}) => {
  const [value, setValue] = useState<Dayjs | null>(null);
  const handleAcceptValue = () => {
    addSlot(value)
    onClose()
  }
    return (
        <Overlay isOpen={isOpen} onClose={onClose}>
            <div className = "mt-10">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={["DesktopDateTimePicker"]}>
            <div className="">
            <DemoItem>
             <StaticDateTimePicker orientation= {"landscape"} value = {value} onChange={(newValue) => setValue(newValue)} onAccept = {handleAcceptValue}/>
            </DemoItem>
            </div>
          </DemoContainer>
        </LocalizationProvider>
        </div>
        </Overlay>
    )
}

export default AddSlotModal